import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IBrandListWithIdModel } from '../models/models'

export class GetBrandListWithIdApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/campaignBundle/getBrandListWithId',
      requesterInfo,
    })
  }

  public async getBrandListWithId(): Promise<IBrandListWithIdModel> {
    return await this.getAsync<IBrandListWithIdModel>()
  }
}
